import React, { useState, useEffect } from 'react';
import api from '../../api/axiosInstance';
import {
    Search,
    Package,
    Eye,
    Edit2,
    Trash2,
    ChevronLeft,
    ChevronRight,
    Loader2,
    AlertCircle,
    Store
} from 'lucide-react';

const AllShop = () => {
    const [shops, setShops] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState({ name: '', package: 'All' });
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedShop, setSelectedShop] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const shopsPerPage = 7;
    const [allMembershipPlans, setAllMembershipPlans] = useState([]);
    const [selectedPackages, setSelectedPackages] = useState({});
    const [paymentDetail, setPaymentDetail] = useState([])

    // Fetch Membership Plans
    const handleFetchMembershipPlans = async () => {
        try {
            const response = await api.get('/admin-packages');
            setAllMembershipPlans(response.data.packages);
        } catch (error) {
            console.error("Error fetching membership plans:", error);
        }
    };

    const fetchPaymentDetail = async () => {
        try {
            const response = await api.get('/get-payment-detail');
            setPaymentDetail(response.data);
        } catch (error) {
            console.error("Error fetching payment details:", error);
        }
    };

    useEffect(() => {
        handleFetchMembershipPlans();
        fetchPaymentDetail();
    }, []);

    const fetchShops = async () => {
        try {
            setLoading(true);
            const res = await api.get('/all-shops');
            console.log("res.data", res.data)
            setShops(res.data.reverse());
            setError(null);
        } catch (error) {
            setError('Failed to fetch shops. Please try again later.');
            console.error('Error fetching shops:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShops();
    }, []);

    // Handle Package Update
    const handleUpdatePackage = async (shopId, packageId) => {
        try {
            if (!packageId) {
                alert("Please select a valid package.");
                return;
            }
            await api.put(`/admin-update-package/${shopId}`, { packageId });
            alert("Package updated successfully!");

            // Update local state to reflect change
            // setShops((prevShops) =>
            //     prevShops.map((shop) =>
            //         shop._id === shopId ? { ...shop, ListingPlan: packageId } : shop
            //     )
            // );
        } catch (error) {
            console.log("Error updating package:", error);
            alert("Failed to update package.");
        }
    };

    const handleView = (id, Name) => {
        window.location.href = `/All-Post?id=${id}`
    };



    const handleDelete = async (id) => {
        try {
            await api.delete(`/delete-shop/${id}`);
            setShops(shops.filter(shop => shop._id !== id));
            setDeleteModalOpen(false);
        } catch (error) {
            console.error('Error deleting shop:', error);
        }
    };

    const filteredShops = shops.filter((shop) => {
        return (
            shop.ShopName.toLowerCase().includes(filter.name.toLowerCase()) &&
            (filter.package === 'All' || shop.ListingPlan === filter.package)
        );
    });

    const indexOfLastShop = currentPage * shopsPerPage;
    const indexOfFirstShop = indexOfLastShop - shopsPerPage;
    const currentShops = filteredShops.slice(indexOfFirstShop, indexOfLastShop);
    const totalPages = Math.ceil(filteredShops.length / shopsPerPage);

    const getPaymentTime = (id) => {
        const foundCategory = paymentDetail.find(cat => cat.razorpay_order_id === id);
        if (foundCategory && foundCategory.createdAt) {
            // Create a new Date object from the ISO string
            const date = new Date(foundCategory.createdAt);
    
            // Format the date to a readable string (e.g., 'December 25, 2024 10:05 AM')
            const formattedDate = date.toLocaleString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true // Use 12-hour format with AM/PM
            });
    
            return formattedDate;
        } else {
            return "No Available";
        }
    };
    

    const getMembershipDetail = (name) => {
        const foundCategory = allMembershipPlans.find(cat => cat.packageName === name);
        return foundCategory ? foundCategory.packagePrice : "No Available";
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[400px]">
                <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
                <p className="text-gray-600">{error}</p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg  p-6">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800 flex items-center mb-4 sm:mb-0">
                    <Store className="w-6 h-6 mr-2" />
                    All Shops
                </h1>

                <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                    <div className="relative">
                        <input
                            type="text"
                            value={filter.name}
                            onChange={(e) => setFilter({ ...filter, name: e.target.value })}
                            placeholder="Search shops..."
                            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full"
                        />
                        <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                    </div>

                    <select
                        value={filter.package}
                        onChange={(e) => setFilter({ ...filter, package: e.target.value })}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                        <option value="All">All Packages</option>
                        <option value="Free">Free</option>
                        <option value="Gold">Gold</option>
                        <option value="Silver">Silver</option>
                    </select>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Shop</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gst No.</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paid Amount</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paid Date</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Package</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Posts</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Update Package</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {currentShops.map((shop) => (
                            <tr key={shop._id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div>
                                            <div className="text-sm font-medium text-gray-900">{shop.ShopName}</div>
                                            <div className="text-sm text-gray-500">{shop.Email}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="text-sm text-gray-900 max-w-xs">
                                        {shop.ShopAddress.ShopAddressStreet}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{shop.ContactNumber}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {shop.gstNo || 0}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                   Rs. {getMembershipDetail(shop.ListingPlan) || 0}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {getPaymentTime(shop.OrderId) || 0}
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                    ${shop.ListingPlan === 'Gold' ? 'bg-yellow-100 text-yellow-800' :
                                            shop.ListingPlan === 'Silver' ? 'bg-gray-100 text-gray-800' :
                                                'bg-green-100 text-green-800'}`}>
                                        <Package className="w-4 h-4 mr-1" />
                                        {shop.ListingPlan}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {shop.HowMuchOfferPost || 0}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <select
                                        value={selectedPackages[shop._id] || ""} // Get the selected value per shop
                                        onChange={(e) => {
                                            const packageId = e.target.value;
                                            setSelectedPackages((prev) => ({ ...prev, [shop._id]: packageId })); // Update state
                                            handleUpdatePackage(shop._id, packageId);
                                        }}
                                        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    >
                                        <option value="">--Select--</option>
                                        {allMembershipPlans.map((plan) => (
                                            <option key={plan._id} value={plan._id}>
                                                {plan.packageName}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() => handleView(shop._id, shop.ShopName)}
                                            className="text-blue-600 hover:text-blue-900"
                                        >
                                            <Eye className="w-5 h-5" />
                                        </button>

                                        <button
                                            onClick={() => {
                                                setSelectedShop(shop);
                                                setDeleteModalOpen(true);
                                            }}
                                            className="text-red-600 hover:text-red-900"
                                        >
                                            <Trash2 className="w-5 h-5" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-between px-4 py-3 border-t border-gray-200 sm:px-6 mt-4">
                <div className="flex justify-between items-center w-full">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <ChevronLeft className="w-5 h-5" />
                    </button>
                    <span className="text-sm text-gray-700">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <ChevronRight className="w-5 h-5" />
                    </button>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            {deleteModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
                        <h3 className="text-lg font-medium text-gray-900 mb-4">Delete Shop</h3>
                        <p className="text-sm text-gray-500 mb-4">
                            Are you sure you want to delete {selectedShop.ShopName}? This action cannot be undone.
                        </p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setDeleteModalOpen(false)}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => handleDelete(selectedShop._id)}
                                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllShop;